import { useState, useEffect } from 'react';
import { payment_error_translations_map } from '../config/consts.js';
import { usePaymentContext } from '../providers/PaymentContextProvider.js';
import { checkApplePaySupported } from '../utils/modernizePaymentUtils.js';

const payment_error_map = {
    APPLEPAY_NOT_SUPPORTED: {
        errorCode: 'APPLEPAY_NOT_SUPPORTED',
    },
};
const usePaymentErrors = () => {
    const { checkoutState } = usePaymentContext();
    const [paymentErrors, setPaymentErrors] = useState([]);
    const { paymentMessages, preferredPayment, isPaymentCollapsed, setIsPaymentCollapsed, addPaymentFrontendError, } = checkoutState || {};
    const { paymentMethodShortName } = preferredPayment || {};
    useEffect(() => {
        const paymentMessagesHasAPError = !!paymentMessages?.find(({ errorCode }) => errorCode === 'APPLEPAY_NOT_SUPPORTED');
        if (isPaymentCollapsed &&
            paymentMethodShortName === 'AP' &&
            !paymentMessagesHasAPError &&
            payment_error_map.APPLEPAY_NOT_SUPPORTED &&
            !checkApplePaySupported()) {
            addPaymentFrontendError?.(payment_error_map.APPLEPAY_NOT_SUPPORTED);
            setIsPaymentCollapsed?.(false);
        }
        if (paymentMessages) {
            setPaymentErrors(paymentMessages.map((paymentMessage) => {
                const errorCode = paymentMessage.errorCode;
                return (payment_error_translations_map[errorCode] ||
                    payment_error_translations_map.UNKNOWN_ERROR);
            }));
        }
    }, [JSON.stringify(paymentMessages)]);
    return [paymentErrors];
};

export { usePaymentErrors as default };
//# sourceMappingURL=usePaymentErrors.js.map
